/* eslint-disable no-eval */
// Components==============
import Button from 'components/UI/Button';
import Modal from 'components/UI/Modal';
import RichText from 'components/UI/RichText';
import React from 'react';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
import './index.module.scss';
// =========================

export default function EventsCardModal({ events }) {
    const openSubscribe = useOpenUrlModal(`aanmelden`);

    // // format start date
    const formattedDate = new Date(
        events?.date || events?.start_date
    ).toLocaleDateString('nl-NL', {
        timeZone: 'Europe/Amsterdam',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    return (
        <Modal slug={`/agenda/event-popup/${events?.id}`} exact>
            <div styleName="wrapper">
                <div styleName="top">
                    <p styleName="label">Meer informatie over</p>
                    <h1>{events?.title || events?.name}</h1>
                    <p>{formattedDate}</p>
                </div>
                <RichText
                    richText={eval(events?.content || events?.description)}
                />
                {events?.enrollment_open ? (
                    <>
                        <br />
                        <Button onClick={openSubscribe}>Aanmelden</Button>
                    </>
                ) : null}
            </div>
        </Modal>
    );
}
